import { isNil } from 'lodash';
import { createSelector } from 'reselect';

export const getSkips = state => state.skips;

const getSkipsData = createSelector(getSkips, skips => skips.data || {});

export const isSkipped = userUid =>
  createSelector(getSkipsData, skipsData => !isNil(skipsData[userUid]));